import React, { ComponentType, CSSProperties, ReactChildren } from 'react'
import 'styled-components/macro'
import { Navbar } from '../Navbar'
import { Container, ChildrenContainer } from './styledComponents'

interface NavbarWrapperProps {
  children
  logo: ComponentType
  navbarStyles?: CSSProperties
  containerCSS?: CSSProperties
}

export const NavbarWrapper = (props: NavbarWrapperProps) => {
  const { children: Children, logo, navbarStyles, containerCSS } = props

  return (
    <Container css={containerCSS}>
      <Navbar logo={logo} navbarStyles={navbarStyles} />
      <ChildrenContainer>{Children}</ChildrenContainer>
    </Container>
  )
}
